import React from 'react';
import { Checkbox } from '../../../components/ui/Checkbox';
import { Link } from 'react-router-dom';

const ConsentSection = ({ formData, errors, onChange }) => {
  const handleCheckboxChange = (name) => (e) => {
    onChange({ target: { name, value: e?.target?.checked } });
  };

  return (
    <div className="rounded-lg bg-card p-6 shadow-lg transition-all duration-300 hover:shadow-xl">
      <h2 className="mb-6 text-xl font-bold text-foreground">동의 사항</h2>
      <div className="space-y-4">
        <Checkbox
          label="카카오톡 알림 수신에 동의합니다"
          description="주문 상태 업데이트를 카카오톡으로 받으실 수 있습니다"
          checked={formData?.kakaoConsent}
          onChange={handleCheckboxChange('kakaoConsent')}
          error={errors?.kakaoConsent}
        />
        <Checkbox
          label={
            <span>
              <Link to="/terms-and-conditions" className="text-accent hover:underline">
                이용약관
              </Link>
              에 동의합니다
            </span>
          }
          description={`서비스 이용을 위해 필수적으로 동의해야 합니다\n주문 후 안내드리는 계좌로 결제하시면\n픽업 일정이 확정됩니다.`}
          checked={formData?.termsConsent}
          onChange={handleCheckboxChange('termsConsent')}
          error={errors?.termsConsent}
          required
        />
      </div>
    </div>
  );
};

export default ConsentSection;